(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8101],{

/***/ 23257:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var apiToAlert = function apiToAlert(apiError) {
  return {
    analyticsLabel: apiError.response || "API returned ".concat(JSON.stringify(apiError)),
    children: apiError.explanation || 'Oh no!',
    heading: apiError.response || 'Something went wrong',
    level: apiError.level || 'danger'
  };
};
var _default = exports["default"] = apiToAlert;
module.exports = exports.default;

/***/ }),

/***/ 11845:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var _constants = _interopRequireDefault(__webpack_require__(13294));
var _isValidScale = _interopRequireDefault(__webpack_require__(18049));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SINGLE_SCALES = [_constants["default"].SCALE.SINGLE];
var _default = exports["default"] = (0, _fp.memoize)(function (scale) {
  if (!(0, _isValidScale["default"])(scale)) {
    return _constants["default"].INCOME_TYPE.SINGLE;
  }
  return (0, _fp.includes)(scale, SINGLE_SCALES) ? _constants["default"].INCOME_TYPE.SINGLE : _constants["default"].INCOME_TYPE.COUPLE;
});
module.exports = exports.default;

/***/ }),

/***/ 18049:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var _constants = _interopRequireDefault(__webpack_require__(13294));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = (0, _fp.memoize)(function (scale) {
  return (0, _fp.includes)(scale, _constants["default"].SCALE);
});
module.exports = exports.default;

/***/ }),

/***/ 15349:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/youth-discount",
      function () {
        return __webpack_require__(96713);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41801:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/phone.6a45fa94.svg","height":104,"width":94});

/***/ }),

/***/ 96713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./src/client/utils/get-saleable-product-ids/index.ts
var get_saleable_product_ids = __webpack_require__(93216);
// EXTERNAL MODULE: ./src/client/actions/product/index.ts
var product = __webpack_require__(15311);
// EXTERNAL MODULE: ./src/client/models/product/index.ts + 32 modules
var models_product = __webpack_require__(43735);
;// CONCATENATED MODULE: ./src/client/models/product/fetch-all-product-data.ts




// @ts-expect-error - Automatic, Please fix when editing this file
var fetchAllProductData = function(state, dispatch) {
    var products = state.product.data;
    var saleableProductIds = (0,get_saleable_product_ids/* default */.Z)();
    var productIdsToLoad = (0,fp.reject)(function(productId) {
        return models_product/* default.getProduct */.Z.getProduct(products, productId);
    }, saleableProductIds);
    if ((0,fp.isEmpty)(productIdsToLoad)) {
        return Promise.resolve();
    }
    var action = product/* default.load */.Z.load(productIdsToLoad);
    return dispatch(action);
};
/* harmony default export */ var fetch_all_product_data = (fetchAllProductData);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/components/all-products-data-loader/index.ts
var all_products_data_loader = __webpack_require__(76988);
;// CONCATENATED MODULE: ./src/client/pages/youth-discount/images/41-cake.svg
/* harmony default export */ var _41_cake = ({"src":"/_next/static/media/41-cake.e8d15bb9.svg","height":118,"width":293});
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
// EXTERNAL MODULE: ./src/client/components/legacy-bordered-wrapper/index.tsx
var legacy_bordered_wrapper = __webpack_require__(78558);
// EXTERNAL MODULE: ./src/client/models/price/load-price-for-component-props.ts
var load_price_for_component_props = __webpack_require__(14518);
;// CONCATENATED MODULE: ./src/client/pages/youth-discount/images/money-flying.svg
/* harmony default export */ var money_flying = ({"src":"/_next/static/media/money-flying.dc3d501e.svg","height":234,"width":247});
;// CONCATENATED MODULE: ./src/client/pages/youth-discount/images/money-pocket.svg
/* harmony default export */ var money_pocket = ({"src":"/_next/static/media/money-pocket.d62cbb3b.svg","height":262,"width":137});
;// CONCATENATED MODULE: ./src/client/pages/youth-discount/images/money-wave.svg
/* harmony default export */ var money_wave = ({"src":"/_next/static/media/money-wave.bab55a65.svg","height":85,"width":133});
// EXTERNAL MODULE: ./src/client/images/phone.svg
var phone = __webpack_require__(41801);
// EXTERNAL MODULE: ./src/client/actions/price/index.ts
var price = __webpack_require__(77061);
// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/claim/format-currency/index.js
var format_currency = __webpack_require__(79649);
var format_currency_default = /*#__PURE__*/__webpack_require__.n(format_currency);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/client/pages/youth-discount/components/slider-box/constants.ts

var staticFrequency = ahm_constants/* default.PAYMENT_FREQUENCY.YEARLY */.Z.PAYMENT_FREQUENCY.YEARLY;
var scale = ahm_constants/* default.SCALE.SINGLE */.Z.SCALE.SINGLE;
var marks = {
    18: "18",
    25: "25",
    26: "26",
    27: "27",
    28: "28",
    29: "29",
    30: "30+"
};
var percentages = {
    18: 0.1,
    19: 0.1,
    20: 0.1,
    21: 0.1,
    22: 0.1,
    23: 0.1,
    24: 0.1,
    25: 0.1,
    26: 0.08,
    27: 0.06,
    28: 0.04,
    29: 0.02,
    30: 0
};
var productId = ahm_constants/* default.PRODUCT.STARTER_BRONZE_EXCESS_750 */.Z.PRODUCT.STARTER_BRONZE_EXCESS_750;


// EXTERNAL MODULE: ./src/client/config.ts
var config = __webpack_require__(75624);
// EXTERNAL MODULE: ./src/client/actions/customer/index.ts
var customer = __webpack_require__(91395);
// EXTERNAL MODULE: ./src/client/utils/get-date-of-birth-from-age/index.ts
var get_date_of_birth_from_age = __webpack_require__(9805);
// EXTERNAL MODULE: ./src/client/models/price/index.ts
var models_price = __webpack_require__(2798);
;// CONCATENATED MODULE: ./src/client/pages/youth-discount/utils/get-youth-discount-savings/index.tsx


// @ts-expect-error - Automatic, Please fix when editing this file
var getYouthDiscountSavings = function(param) {
    var customer = param.customer, frequency = param.frequency, prices = param.prices, productId = param.productId, priceOptions = param.priceOptions;
    var ref, ref1;
    if ((0,fp.isEmpty)(prices)) {
        return null;
    }
    var priceWithoutDiscount = models_price/* default.getPrice */.Z.getPrice(prices, productId, (0,fp.omit)("members", customer), priceOptions);
    var priceWithDiscount = models_price/* default.getPrice */.Z.getPrice(prices, productId, customer, priceOptions);
    if ((0,fp.isNil)(priceWithoutDiscount) || (0,fp.isNil)(priceWithDiscount)) {
        return null;
    }
    var frequencyWithoutDiscount = priceWithoutDiscount === null || priceWithoutDiscount === void 0 ? void 0 : (ref = priceWithoutDiscount.amount) === null || ref === void 0 ? void 0 : ref[frequency];
    var frequencyWithDiscount = priceWithDiscount === null || priceWithDiscount === void 0 ? void 0 : (ref1 = priceWithDiscount.amount) === null || ref1 === void 0 ? void 0 : ref1[frequency];
    if (!(0,fp.isString)(frequencyWithoutDiscount) || !(0,fp.isString)(frequencyWithDiscount)) {
        return null;
    }
    // @ts-expect-error - Automatic, Please fix when editing this file
    var savings = frequencyWithoutDiscount - frequencyWithDiscount;
    return Math.max(savings, 0);
};
/* harmony default export */ var get_youth_discount_savings = (getYouthDiscountSavings);

// EXTERNAL MODULE: ./src/client/components/premium-review-toggle-wrapper/index.tsx + 2 modules
var premium_review_toggle_wrapper = __webpack_require__(12224);
// EXTERNAL MODULE: ./src/client/pages/youth-discount/components/slider-box/styles.module.sass
var styles_module = __webpack_require__(6271);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/client/pages/youth-discount/components/slider-box/components/tip-formatter/styles.module.sass
var tip_formatter_styles_module = __webpack_require__(71560);
var tip_formatter_styles_module_default = /*#__PURE__*/__webpack_require__.n(tip_formatter_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/youth-discount/components/slider-box/components/tip-formatter/index.tsx





// @ts-expect-error - Automatic, Please fix when editing this file
var tipFormatter = function(value) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Strong */.cK, {
                variant: [
                    (tip_formatter_styles_module_default()).tooltip
                ],
                children: [
                    (percentages[value] || 0) * 100,
                    "%"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (tip_formatter_styles_module_default()).tooltipTitle,
                children: [
                    "youth ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "discount"
                ]
            })
        ]
    });
};
/* harmony default export */ var tip_formatter = (tipFormatter);

;// CONCATENATED MODULE: ./src/client/pages/youth-discount/components/slider-box/index.tsx
























var ages = (0,fp.keys)(percentages);
var getFutureEffectiveDate = moment_default()(config/* default.get */.Z.get("features:premiumChange:futureEffectiveDate")).format(ahm_constants/* default.DATE_FORMAT.ISO_8601 */.Z.DATE_FORMAT.ISO_8601);
// @ts-expect-error - Automatic, Please fix when editing this file
var getDefaultCustomerPriceData = function(customer, age) {
    // We force price request data to be consistent, ignoring what
    // the user might have in redux state
    var output = {
        ageBracket: ahm_constants/* default.REBATE_AGE_BRACKET.BRACKET_0 */.Z.REBATE_AGE_BRACKET.BRACKET_0,
        frequency: staticFrequency,
        incomeTier: ahm_constants/* default.INCOME_TIER.TIER_0 */.Z.INCOME_TIER.TIER_0,
        incomeType: ahm_constants/* default.INCOME_TYPE.SINGLE */.Z.INCOME_TYPE.SINGLE,
        rebate: false,
        scale: scale,
        state: customer.state
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    if (percentages[age] > 0) {
        // @ts-expect-error - Automatic, Please fix when editing this file
        output.members = [
            {
                continuous: true,
                dob: (0,get_date_of_birth_from_age/* default */.Z)(age),
                relationship: "client"
            }, 
        ];
    }
    return output;
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getPriceOptions = function(useFutureEffectiveDate) {
    var futureEffectiveDate = useFutureEffectiveDate ? getFutureEffectiveDate : null;
    return (0,fp.omitBy)(fp.isNull, {
        adjustedScale: true,
        date: futureEffectiveDate,
        lhc: false
    });
};
var SliderBox = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SliderBox, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SliderBox);
    function SliderBox() {
        (0,_class_call_check/* default */.Z)(this, SliderBox);
        var _this;
        _this = _super.apply(this, arguments);
        // @ts-expect-error - Automatic, Please fix when editing this file
        _this.state = {
            age: 18
        };
        // @ts-expect-error - Automatic, Please fix when editing this file
        _this.onSliderChange = function(age) {
            _this.setState({
                age: age
            });
        };
        return _this;
    }
    var _proto = SliderBox.prototype;
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.componentDidMount = function componentDidMount() {
        var _props = this.props, actions = _props.actions, customer = _props.customer, useFutureEffectiveDate = _props.useFutureEffectiveDate;
        SliderBox.retrievePrices(actions.price, customer, useFutureEffectiveDate);
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _props = this.props, actions = _props.actions, customer = _props.customer, useFutureEffectiveDate = _props.useFutureEffectiveDate;
        if (useFutureEffectiveDate !== prevProps.useFutureEffectiveDate) {
            SliderBox.retrievePrices(actions.price, customer, useFutureEffectiveDate);
        }
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.render = function render() {
        var _props = this.props, customer = _props.customer, prices = _props.prices, products = _props.products, useFutureEffectiveDate = _props.useFutureEffectiveDate;
        var age = this.state.age;
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
        if (!(products === null || products === void 0 ? void 0 : products[productId])) {
            return null;
        }
        var customerData = getDefaultCustomerPriceData(customer, age);
        var savings = get_youth_discount_savings({
            customer: customerData,
            frequency: staticFrequency,
            priceOptions: getPriceOptions(useFutureEffectiveDate),
            prices: prices,
            productId: productId
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderBox */.xw, {
            variant: [
                (styles_module_default()).ageSelectionBox,
                "thin"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                        variant: "marginBottomSpacer9",
                        children: "How much can I save on my hospital cover?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_review_toggle_wrapper/* default */.ZP, {
                        type: "alternativePage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                        children: "Select your age below to begin"
                    }),
                    (0,fp.isNull)(savings) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Spinner */.$j, {
                        variant: (styles_module_default()).spinner
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).slider,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Slider */.iR, {
                                        analytics: {
                                            action: "on_youth_discount_age_move_slider",
                                            component: "youth_discount"
                                        },
                                        onChange: this.onSliderChange,
                                        marks: marks,
                                        min: 18,
                                        max: 30,
                                        tipFormatter: tip_formatter,
                                        ariaLabelForHandle: "discount"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                        looksLike: "h4",
                                        variant: [
                                            "marginBottomSpacer7",
                                            (styles_module_default()).results
                                        ],
                                        children: savings === 0 ? "You don’t qualify for a discount, but we still have affordable cover available." : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                "If you’re ",
                                                (0,fp.toLower)(scale),
                                                " in ",
                                                ahm_constants/* default.STATE_LABEL */.Z.STATE_LABEL[customerData.state],
                                                " you could save up to",
                                                " ",
                                                format_currency_default()(savings),
                                                " a year on ",
                                                products[productId].name,
                                                " product",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                    children: "*"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            savings > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                                variant: [
                                    "marginBottomSpacer7",
                                    (styles_module_default()).disclaimer
                                ],
                                "data-testid": "disclaimer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                        children: "*"
                                    }),
                                    "Paying by direct debit. Australian Government Rebate is not applied. ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "Hospital price includes an excess of $750 and excludes Lifetime Health Cover loading. ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "Youth Discount only applies to hospital component."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                                variant: "sharp",
                                to: ahm_constants/* default.URLS.SALES.PRODUCT_LISTING_HOSPITAL */.Z.URLS.SALES.PRODUCT_LISTING_HOSPITAL,
                                children: "View all hospital cover"
                            })
                        ]
                    })
                ]
            })
        });
    };
    return SliderBox;
}(react.PureComponent);
// @ts-expect-error - Automatic, Please fix when editing this file
SliderBox.retrievePrices = function(pricActions, customer, useFutureEffectiveDate) {
    (0,fp.forEach)(function(age) {
        pricActions.load(productId, {
            customer: getDefaultCustomerPriceData(customer, age)
        }, getPriceOptions(useFutureEffectiveDate));
    }, ages);
};
var mapStateToProps = function(state) {
    return {
        customer: (0,select_customer/* default */.Z)(state),
        prices: state.price.data,
        products: state.product.data,
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            customer: (0,redux/* bindActionCreators */.DE)(customer/* default */.Z, dispatch),
            price: (0,redux/* bindActionCreators */.DE)(price/* default */.Z, dispatch),
            product: (0,redux/* bindActionCreators */.DE)(product/* default */.Z, dispatch)
        }
    };
};
/* harmony default export */ var slider_box = ((0,redux/* compose */.qC)(all_products_data_loader/* default */.Z, (0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps))(SliderBox));


// EXTERNAL MODULE: ./src/client/pages/youth-discount/styles.module.sass
var youth_discount_styles_module = __webpack_require__(58618);
var youth_discount_styles_module_default = /*#__PURE__*/__webpack_require__.n(youth_discount_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/youth-discount/images/youth-discount-group.svg
/* harmony default export */ var youth_discount_group = ({"src":"/_next/static/media/youth-discount-group.601bbdc9.svg","height":252,"width":609});
;// CONCATENATED MODULE: ./src/client/pages/youth-discount/index.tsx























var YouthDiscountPage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(YouthDiscountPage, PureComponent);
    var _super = (0,_create_super/* default */.Z)(YouthDiscountPage);
    function YouthDiscountPage() {
        (0,_class_call_check/* default */.Z)(this, YouthDiscountPage);
        return _super.apply(this, arguments);
    }
    var _proto = YouthDiscountPage.prototype;
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.componentDidMount = function componentDidMount() {
        // @ts-expect-error - Automatic, Please fix when editing this file
        load_price_for_component_props/* default.componentDidMount */.Z.componentDidMount(this.props);
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        load_price_for_component_props/* default.componentWillReceiveProps */.Z.componentWillReceiveProps(prevProps, this.props);
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(legacy_bordered_wrapper/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: "Youth discount | Health insurance for young adults"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: "Aged 18-29 years old? You could be eligible for a discount on hospital cover. Learn more about Health Insurance for young adults with ahm today."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* FullScreenHeader */.Ld, {
                            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "Youth Discount ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "is here"
                                ]
                            }),
                            subtitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "If you’re aged 18 – 29 and a Principal member or partner, you can get a discount on your hospital cover."
                            }),
                            scrollToElementId: "benefits",
                            scrollToElementText: "The ins and outs of the youth discount"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "benefits",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                                variant: [
                                    "simpleBit",
                                    "center"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Wrapper */.im, {
                                    className: (youth_discount_styles_module_default()).benefits,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                            variant: "marginBottomSpacer7",
                                            children: "So, how do I get the Youth Discount?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Row */.X2, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Col */.JX, {
                                                    variant: (youth_discount_styles_module_default()).singleBenefit,
                                                    df: 4,
                                                    lg: 4,
                                                    sm: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (youth_discount_styles_module_default()).image,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                                                src: phone/* default.src */.Z.src,
                                                                role: "presentation"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                                                            looksLike: "h4",
                                                            children: "Choose any hospital product"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                                            variant: (youth_discount_styles_module_default()).benefitContent,
                                                            children: "You’ll find the discount on any ahm hospital product"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Col */.JX, {
                                                    variant: (youth_discount_styles_module_default()).singleBenefit,
                                                    df: 4,
                                                    lg: 4,
                                                    sm: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (youth_discount_styles_module_default()).image,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                                                src: money_wave.src,
                                                                role: "presentation"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                                                            looksLike: "h4",
                                                            children: "Pocket the savings"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                                            variant: (youth_discount_styles_module_default()).benefitContent,
                                                            children: "You could save on the hospital component of your premium"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Col */.JX, {
                                                    df: 4,
                                                    lg: 4,
                                                    sm: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (youth_discount_styles_module_default()).image,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                                                src: _41_cake.src,
                                                                role: "presentation"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                                                            looksLike: "h4",
                                                            children: "Keep saving"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                                            variant: (youth_discount_styles_module_default()).benefitContent,
                                                            children: "Keep continuous hospital cover and maintain the discount until you turn 41"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(slider_box, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Wrapper */.im, {
                            className: (youth_discount_styles_module_default()).additionalInfo,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (youth_discount_styles_module_default()).singleAdditionalInfo,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                            looksLike: "h3",
                                            variant: "marginBottomSpacer9",
                                            children: "How does the Youth Discount work?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                            children: "The Youth Discount helps make private health insurance for young adults more affordable."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                            children: "So, if you’re a young adult aged 18 – 29 and a Principal Member or partner, you can get a discount on your ahm hospital cover, or the hospital part of a health insurance package."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                            children: "Plus, if you keep your hospital cover, the Youth Discount will continue to apply until you turn 41. Basically, the sooner you join ahm before you turn the big 3-0 the more you could save on hospital cover."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                                to: ahm_constants/* default.URLS.HELP.YOUTH_DISCOUNT */.Z.URLS.HELP.YOUTH_DISCOUNT,
                                                children: "Learn how the youth discount is calculated."
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Hidden */._G, {
                                    xs: true,
                                    sm: true,
                                    md: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                            src: money_pocket.src,
                                            role: "presentation",
                                            className: (youth_discount_styles_module_default()).imageRight
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                            src: money_flying.src,
                                            role: "presentation",
                                            className: (youth_discount_styles_module_default()).imageBottomLeft
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (youth_discount_styles_module_default()).singleAdditionalInfo,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                            looksLike: "h3",
                                            variant: "marginBottomSpacer9",
                                            children: "Stick with us and your discount will be ongoing"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                            src: youth_discount_group.src,
                                            role: "presentation",
                                            className: (youth_discount_styles_module_default()).youthDiscountGroupImage
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                            children: "If you maintain continuous hospital cover, the Youth Discount you get when you first become eligible will stay the same every year until you turn 41."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                            children: "It then reduces by 2% every year on your birthday and until it gets to zero."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                            children: "For example, if you first take out hospital cover when you’re 26, you’ll keep the 8% discount until you’re 41 if you maintain hospital cover. Then it will decrease by 2% each year on your birthday until the discount has been removed."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (youth_discount_styles_module_default()).singleAdditionalInfo,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                            looksLike: "h3",
                                            variant: "marginBottomSpacer9",
                                            children: "Transferring from another fund?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                                            children: [
                                                "If you’re switching to ahm from another fund with a Youth Discount applied to your hospital product, you may be able to transfer the Youth Discount with you.",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                                    to: ahm_constants/* default.URLS.SALES.FIND_HEALTH_INSURANCE */.Z.URLS.SALES.FIND_HEALTH_INSURANCE,
                                                    children: "Switch to us now."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                    looksLike: "h3",
                                    variant: "marginBottomSpacer9",
                                    children: "Need help?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                                    children: [
                                        "Our ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                            to: ahm_constants/* default.URLS.HELP.YOUTH_DISCOUNT */.Z.URLS.HELP.YOUTH_DISCOUNT,
                                            children: "Help"
                                        }),
                                        " and support pages can answer some pretty detailed questions, but if you’d prefer to chat to a human,",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                            to: ahm_constants/* default.URLS.SALES.CONTACT_US */.Z.URLS.SALES.CONTACT_US,
                                            children: "contact us"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return YouthDiscountPage;
}(react.PureComponent);
var youth_discount_mapStateToProps = function(state) {
    return {
        customer: (0,select_customer/* default */.Z)(state),
        prices: state.price.data,
        products: state.product.data
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var youth_discount_mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            price: (0,redux/* bindActionCreators */.DE)(price/* default */.Z, dispatch)
        }
    };
};
/* harmony default export */ var youth_discount = ((0,redux/* compose */.qC)(all_products_data_loader/* default */.Z, (0,es/* connect */.$j)(youth_discount_mapStateToProps, youth_discount_mapDispatchToProps))(YouthDiscountPage));


;// CONCATENATED MODULE: ./src/client/routes/components/with-load-data/index.tsx



// @ts-expect-error - Automatic, Please fix when editing this file
var withLoadData = function(Component, loadData) {
    return function(routeProps) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({
            loadData: loadData
        }, routeProps));
    };
};
/* harmony default export */ var with_load_data = (withLoadData);

;// CONCATENATED MODULE: ./pages/youth-discount/index.page.ts




// @ts-expect-error - Automatic, Please fix when editing this file
var YouthPage = function(props) {
    return with_load_data(youth_discount, fetch_all_product_data)((0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var index_page = (YouthPage);


/***/ }),

/***/ 77061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23094);
/* harmony import */ var _utils_get_customer_age_bracket__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29874);
/* harmony import */ var _models_price__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2798);
/* harmony import */ var _selectors_select_customer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34112);





// @ts-expect-error - Automatic, Please fix when editing this file
function load(productIds) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(dispatch, getState) {
        var globalState = getState();
        var customer = (0,_selectors_select_customer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(data) || (0,_selectors_select_customer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(globalState) || {};
        var ageBracket = (0,_utils_get_customer_age_bracket__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(customer);
        var productIdsArray = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isArray)(productIds) ? productIds : [
            productIds
        ];
        var conditions = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.pick)([
            "dependants",
            "incomeTier",
            "members",
            "rebate",
            "state",
            "scale",
            "starts",
            "payment"
        ], data);
        var conditionsWithDefaults = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.defaultsAll)([
            conditions,
            {
                ageBracket: ageBracket
            },
            customer
        ]);
        var keys = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(productId) {
            return _models_price__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getKey */ .Z.getKey(productId, conditionsWithDefaults, options);
        }, productIdsArray);
        return dispatch({
            keys: keys,
            // @ts-expect-error - Automatic, Please fix when editing this file
            promise: function(api) {
                return _models_price__WEBPACK_IMPORTED_MODULE_2__/* ["default"].loadPrices */ .Z.loadPrices(api, productIdsArray, conditionsWithDefaults, options);
            },
            types: [
                _action_types__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_LOAD */ .f8,
                _action_types__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_LOAD_SUCCESS */ .ZI,
                _action_types__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_LOAD_FAIL */ .Ct
            ]
        });
    };
}
function changeEffectiveDate() {
    var useFutureEffectiveDate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return {
        type: _action_types__WEBPACK_IMPORTED_MODULE_4__/* .CHANGE_EFFECTIVE_DATE */ .Bj,
        useFutureEffectiveDate: useFutureEffectiveDate
    };
}
var PriceActions = {
    changeEffectiveDate: changeEffectiveDate,
    load: load
};
/* harmony default export */ __webpack_exports__["Z"] = (PriceActions);


/***/ }),

/***/ 15311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23094);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43735);



/**
 * Load products into state.
 *
 * @param {string|string[]} productIds - One or a list of product ids.
 * @returns {object} Action.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
function load(productIds) {
    var array = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isString)(productIds) ? [
        productIds
    ] : productIds;
    return {
        productIds: array,
        // @ts-expect-error - Automatic, Please fix when editing this file
        promise: function(api) {
            return _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].loadProducts */ .Z.loadProducts(api, array);
        },
        types: [
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD */ .F9,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_SUCCESS */ .cx,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_FAIL */ .w2
        ]
    };
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    load: load
});


/***/ }),

/***/ 76988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84076);
/* harmony import */ var _utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93216);
/* harmony import */ var _selectors_make_select_has_all_required_products_loaded__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42070);
/* harmony import */ var _selectors_select_products_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50359);




/* harmony default export */ __webpack_exports__["Z"] = ((0,_data_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    selectIsDataLoaded: (0,_selectors_make_select_has_all_required_products_loaded__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)()),
    selectLoadingError: _selectors_select_products_error__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
}));


/***/ }),

/***/ 84076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ data_loader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/assert/assert.js
var assert = __webpack_require__(27596);
var assert_default = /*#__PURE__*/__webpack_require__.n(assert);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/api-to-alert/index.js
var api_to_alert = __webpack_require__(23257);
var api_to_alert_default = /*#__PURE__*/__webpack_require__.n(api_to_alert);
// EXTERNAL MODULE: ./src/client/components/loading-error-alert/styles.module.sass
var styles_module = __webpack_require__(7550);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/loading-error-alert/index.tsx







// @ts-expect-error - Automatic, Please fix when editing this file
var shouldShowLoadingErrorAlert = function(loadingError) {
    return (0,fp.isPlainObject)(loadingError);
};
var LoadingErrorAlert = function(param) {
    var loadingError = param.loadingError;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).section,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Section */.$0, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Alert */.bZ, (0,_object_spread/* default */.Z)({}, api_to_alert_default()(loadingError)))
            })
        })
    });
};
/* harmony default export */ var loading_error_alert = (LoadingErrorAlert);


// EXTERNAL MODULE: ./src/client/components/loading-spinner/index.tsx
var loading_spinner = __webpack_require__(30950);
;// CONCATENATED MODULE: ./src/client/components/data-loader/index.tsx











var dataLoader = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    // @ts-expect-error - Automatic, Please fix when editing this file
    assert_default()((0,fp.isFunction)(options.selectIsDataLoaded), "selectIsDataLoaded option must be a function");
    // @ts-expect-error - Automatic, Please fix when editing this file
    assert_default()((0,fp.isFunction)(options.selectLoadingError), "selectLoadingError option must be a function");
    // @ts-expect-error - Automatic, Please fix when editing this file
    var mapStateToProps = function(state, props) {
        return {
            // @ts-expect-error - Automatic, Please fix when editing this file
            isLoaded: options.selectIsDataLoaded(state, props),
            // @ts-expect-error - Automatic, Please fix when editing this file
            loadingError: options.selectLoadingError(state, props),
            state: state
        };
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    var mapDispatchToProps = function(dispatch) {
        return {
            dispatch: dispatch
        };
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(WrappedComponent) {
        var DataLoader = /*#__PURE__*/ function(PureComponent) {
            "use strict";
            (0,_inherits/* default */.Z)(DataLoader, PureComponent);
            var _super = (0,_create_super/* default */.Z)(DataLoader);
            function DataLoader() {
                (0,_class_call_check/* default */.Z)(this, DataLoader);
                return _super.apply(this, arguments);
            }
            var _proto = DataLoader.prototype;
            // DEPRECATED: not in use for server-side data fetching in NextJS
            // @ts-expect-error - Automatic, Please fix when editing this file
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                var _props = this.props, dispatch = _props.dispatch, history = _props.history, loadData = _props.loadData, match = _props.match, state = _props.state;
                // Define loadData prop in top-level routes config ('../../routes/index.jsx')
                if ((0,fp.isFunction)(loadData)) {
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    loadData(state, dispatch, match.params, history);
                }
            };
            // DEPRECATED: not in use for server-side data fetching in NextJS
            // @ts-expect-error - Automatic, Please fix when editing this file
            _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
                if (prevProps.isLoaded && !this.props.isLoaded) {
                    var _props = this.props, dispatch = _props.dispatch, history = _props.history, loadData = _props.loadData, match = _props.match, state = _props.state;
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    loadData(state, dispatch, match.params, history);
                }
            };
            // @ts-expect-error - Automatic, Please fix when editing this file
            _proto.render = function render() {
                var _props = this.props, isLoaded = _props.isLoaded, loadingError = _props.loadingError;
                if (!isLoaded) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {});
                }
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'timeout' does not exist on type '{ code?: string | undefined; explanation?: string | ReactElement<any, string | JSXElementConstructor<any>> | undefined; response?: string | undefined; }'.
                var errorToShow = (loadingError === null || loadingError === void 0 ? void 0 : loadingError.timeout) ? {
                    explanation: "It seems our servers are taking too long to respond. Please try again later."
                } : loadingError;
                if (shouldShowLoadingErrorAlert(errorToShow)) {
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_error_alert, {
                        loadingError: errorToShow
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, (0,fp.omit)([
                    "dispatch",
                    "state"
                ], this.props)));
            };
            return DataLoader;
        }(react.PureComponent);
        // @ts-expect-error - Automatic, Please fix when editing this file
        DataLoader.defaultProps = {
            history: {
                push: fp.noop
            },
            isLoaded: false,
            loadData: null,
            loadingError: null,
            match: {
                params: {
                    id: null
                }
            }
        };
        return (0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(DataLoader);
    };
};
/* harmony default export */ var data_loader = (dataLoader);


/***/ }),

/***/ 78558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97189);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_4__);





// @ts-expect-error - Automatic, Please fix when editing this file
var LegacyBorderedWrapper = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? null : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Wrapper */ .im, {
        size: "extraExtraLarge",
        isFullWidth: true,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().withBorders), className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LegacyBorderedWrapper);


/***/ }),

/***/ 30950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90937);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_3__);




/**
 * @deprecated If you need to display a transition state for the entire content of a page please
 * prefer LoadingContent to avoid breaking accessibility rules.
 */ var LoadingSpinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default().section),
        "data-testid": "loading-spinner",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Section */ .$0, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Wrapper */ .im, {
                size: "large",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$j, {})
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingSpinner);


/***/ }),

/***/ 14518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84701);
/* harmony import */ var _utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93216);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2798);
/* harmony import */ var _product__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43735);





// @ts-expect-error - Automatic, Please fix when editing this file
var componentDidMount = function(param) {
    var actions = param.actions, customer = param.customer, products = param.products, useFutureEffectiveDate = param.useFutureEffectiveDate;
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flow)(function(productIds) {
        return _product__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getProducts */ .Z.getProducts(products, productIds);
    }, function(productsArray) {
        return _product__WEBPACK_IMPORTED_MODULE_4__/* ["default"].filterAvailableProducts */ .Z.filterAvailableProducts(productsArray, customer);
    }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)("id"), function(productIdsToLoad) {
        return actions.price.load(productIdsToLoad, customer, {
            date: (0,_utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(useFutureEffectiveDate)
        });
    })((0,_utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)());
};
// @ts-expect-error - Automatic, Please fix when editing this file
var componentWillReceiveProps = function(thisProps, nextProps) {
    var thisDate = (0,_utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(thisProps.useFutureEffectiveDate);
    var nextDate = (0,_utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(nextProps.useFutureEffectiveDate);
    // Load prices for available products if the prop change could change pricing.
    var customerChange = ___WEBPACK_IMPORTED_MODULE_3__/* ["default"].getKey */ .Z.getKey("", thisProps.customer, {
        date: thisDate
    }) !== ___WEBPACK_IMPORTED_MODULE_3__/* ["default"].getKey */ .Z.getKey("", nextProps.customer, {
        date: nextDate
    });
    var changedProducts = !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEqual)(thisProps.products, nextProps.products);
    if (customerChange || changedProducts) {
        var customer = nextProps.customer, products = nextProps.products, useFutureEffectiveDate = nextProps.useFutureEffectiveDate;
        var actions = thisProps.actions; // Not sure why this isn’t from next props
        componentDidMount({
            actions: actions,
            customer: customer,
            products: products,
            useFutureEffectiveDate: useFutureEffectiveDate
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    componentDidMount: componentDidMount,
    componentWillReceiveProps: componentWillReceiveProps
});


/***/ }),

/***/ 42070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99846);
/* harmony import */ var _select_raw_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96980);




var makeSelectHasAllRequiredProductsLoaded = function(productList) {
    return (0,reselect__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
        _select_raw_product__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
    ], function(products) {
        var loadedProductIds = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.flow)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.pick)([
            "data"
        ]), (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.flatMap)(lodash_fp__WEBPACK_IMPORTED_MODULE_1__.keys))(products);
        var allLoaded = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.every)(function(productId) {
            return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.includes)(productId, loadedProductIds);
        }, productList);
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'error' does not exist on type 'never'.
        if (!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(products === null || products === void 0 ? void 0 : products.error)) {
            var ref;
            _logging__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getLogger */ .Z.getLogger().error("All required products haven’t loaded", {
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'error' does not exist on type 'never'.
                error: (ref = products === null || products === void 0 ? void 0 : products.error) !== null && ref !== void 0 ? ref : null
            });
        }
        var ref1, ref2;
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'loading' does not exist on type 'never'.
        return allLoaded && (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)((ref1 = products === null || products === void 0 ? void 0 : products.loading) !== null && ref1 !== void 0 ? ref1 : false) || !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)((ref2 = products === null || products === void 0 ? void 0 : products.error) !== null && ref2 !== void 0 ? ref2 : null);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (makeSelectHasAllRequiredProductsLoaded);


/***/ }),

/***/ 50359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _select_raw_product__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96980);

var ref;
// @ts-expect-error - Automatic, Please fix when editing this file
var selectProductsError = function(state) {
    var ref1;
    return (ref = (ref1 = (0,_select_raw_product__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(state)) === null || ref1 === void 0 ? void 0 : ref1.error) !== null && ref !== void 0 ? ref : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (selectProductsError);


/***/ }),

/***/ 84701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47569);

var getFutureDate = function(useFutureEffectiveDate) {
    return useFutureEffectiveDate ? _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FUTURE_EFFECTIVE_DATE */ .Z.FUTURE_EFFECTIVE_DATE : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (getFutureDate);


/***/ }),

/***/ 97189:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","withBorders":"styles_withBorders__jpuBF"};

/***/ }),

/***/ 7550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__Vrua0"};

/***/ }),

/***/ 90937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__LLK5Q"};

/***/ }),

/***/ 71560:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","tooltip":"styles_tooltip__rBJnx","tooltipTitle":"styles_tooltipTitle__Wo_dZ"};

/***/ }),

/***/ 6271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","ageSelectionBox":"styles_ageSelectionBox__WMa7R","slider":"styles_slider__fgguc","results":"styles_results__Z76bv","disclaimer":"styles_disclaimer__EvqQg","spinner":"styles_spinner__gJ8xV"};

/***/ }),

/***/ 58618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","benefits":"styles_benefits__yoygE","additionalInfo":"styles_additionalInfo__pCysz","singleAdditionalInfo":"styles_singleAdditionalInfo__qL_zD","image":"styles_image__0XVye","singleBenefit":"styles_singleBenefit__oc5Js","benefitContent":"styles_benefitContent__NmTdd","imageRight":"styles_imageRight__5JQoI","imageBottomLeft":"styles_imageBottomLeft__JYCeH","youthDiscountGroupImage":"styles_youthDiscountGroupImage__MwF53"};

/***/ }),

/***/ 16567:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 88029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9143,9774,2888,179], function() { return __webpack_exec__(15349); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);